import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Container, Row, Col, Card, CardHeader, CardBody, Button } from 'reactstrap';
import { useAlertPlus } from '../../../hooks';
import AlertModal from '../../../components/AlertModal';
import Form from './Form';
import config from 'config';
import { ApiService } from '../../../services';

import './Edit.scss';

export interface BajaRequest {
  id: string | undefined;
  nombre: string;
  apellido: string;
  delegacion: string;

  motivo_solicitud: string;

  motivo_rechazo: string;
  fecha_desde: string;
  fecha_hasta: string;

  state_id: string;
}

export interface BajaRequestAttachs {
  tipo: string;
  tipo_archivo: string;
  url: string;
}

export interface GalleryItem {
  src: string;
  downloadUrl: string;
  alt: string;
}

function Edit() {
  const { id } = useParams();

  const [data, setData] = useState<BajaRequest>({
    id: id,
    nombre: '',
    apellido: '',

    delegacion: '',

    motivo_solicitud: '',
    fecha_desde: '',
    fecha_hasta: '',

    motivo_rechazo: '',

    state_id: '',
  });

  const [isLoading, setIsLoading] = useState(true);
  const [alertShow, alertMessage, alertCallback, alert] = useAlertPlus('');

  const handleSend = async (accept = false) => {
    try {
      setIsLoading(true);

      // Preparamos los datos
      const formData = new FormData();
      formData.append('motivo_rechazo', data.motivo_rechazo);

      const headers: HeadersInit = {
        ...(localStorage.getItem('accessToken') && {
          Authorization: localStorage.getItem('accessToken') as string,
        }),
      };

      const res = await fetch(`${config.baseUrl}/matriculates/baja/${ id }/${ accept ? 'accept' : 'reject' }`, {
        method: 'POST',
        headers,
        body: formData,
      });

      const response = await res.json();

      if (response?.status !== 'ok') {
        console.info(response);

        if (response.payload?.message) {
          alert(response.payload.message);
          return;
        }

        alert('Ha ocurrido un error al enviar al servidor, por favor intente nuevamente.');
        return;
      }

      alert('Se guardó correctamente la resolución.', () => {
        window.location.href = '/admin/matriculates/requests';
      });
    } catch (err) {
      console.error(err);
      alert('Ha ocurrido un error al guardar la resolución, por favor intente nuevamente.');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    ApiService.getOne('matriculates/baja', id)
      .then(({ payload }) => {
        setData(payload);
      })
      .finally(() =>{
        setIsLoading(false);
      });
  }, [id]);

  return (
    <>
      <div className="header bg-gradient-info pb-8 pt-5 pt-md-8">
        <Container fluid>
          <div className="header-body"></div>
        </Container>
      </div>
      <Container className="mt--7" fluid>
        <Card className="bg-secondary shadow">
          <CardHeader>
            <Row>
              <Col md="8">
                <h3 className="mb-0">Solicitud de Baja #{ id }</h3>
              </Col>
              <Col md="4" className="text-right">
                <Link to='/admin/matriculates/requests'>
                  <Button color="primary" size="md">Volver</Button>
                </Link>
              </Col>
            </Row>
          </CardHeader>
          <CardBody>
            <Form
              data={ data }
              setData={ setData }
              isLoading={ isLoading }
              onAccept={ () => handleSend(true) }
              onReject={ () => handleSend(false) }
            />
          </CardBody>
        </Card>
      </Container>
      <AlertModal isOpen={ alertShow } message={ alertMessage } onClose={ alertCallback } />
    </>
  );
}

export default Edit;
